const common = require('angular').module('wowApp.common');

const inputDirectives = require('./input-directive');

common.directive('wowInputContainer', ['$parse', inputDirectives.inputContainer]);
common.directive('label', [inputDirectives.label]);
common.directive('input', ['GuidFactory', inputDirectives.input]);
common.directive('textarea', ['GuidFactory', inputDirectives.input]);
common.directive('placeholder', [inputDirectives.placeholder]);


/** WEBPACK FOOTER **
 ** ./wowapp/src/common/components/input/index.js
 **/